// extracted by mini-css-extract-plugin
module.exports = {"container":"_5c23371"};